import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { getId } from 'UI/utils';

import { useDialogBodyStyles } from './style';

const DialogBody = ({ itemToRestore }) => {
  const classes = useDialogBodyStyles();

  const details = [
    { field: 'Email', prop: 'email' },
    { field: 'Full Name', prop: 'item_full_name' },
    { field: 'Company', prop: 'company_name' }
  ];

  return (
    <Grid container direction="column" className={classes.root}>
      {details.map(({ field, prop }) => (
        <Grid key={getId()} container item wrap="nowrap">
          <Typography variant="body1">{`${field}:`}</Typography>
          <Typography variant="body1" cropped>
            {itemToRestore[prop] || 'N/A'}
          </Typography>
        </Grid>
      ))}
      <Grid container item className={classes.warning}>
        <Typography variant="subtitle2">IMPORTANT:</Typography>
        <Typography variant="body2">This email will receive bulks again.</Typography>
      </Grid>
    </Grid>
  );
};

export default DialogBody;
